.container {
  display: flex;
  flex-direction: row;
  border: 1px solid var(--border-color);
  border-radius: 0.4rem;
  gap: 0.4rem;
}

.link-wrapper {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 0.4rem;
  align-items: center;
  border: 1px solid var(--color-grey-7);
  border-radius: 0.4rem;
  padding: 0 0.8rem 0 0.8rem;
  height: 4rem;

  & svg {
    stroke: unset;
  }

  & button:hover:enabled,
  & button:focus,
  & button:active {
    & svg {
      stroke: unset;
    }
  }
}

.link {
  color: var(--color-secondary);
  text-decoration: underline;
  font-size: 1.4rem;
  line-height: 1.4rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
}
